<template>
  <div>
    <b-card>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>

      <div v-else>
        <b-row>
          <b-col cols="6" class="mt-1">
            <h4>{{ 'categories_list_title' | translate('global') }}</h4>
          </b-col>
          <b-col cols="6">
            <div class="pull-right">
              <Create/>
            </div>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12">
            <LiquorTree ref="tree"
              :data="categoriesTree"
              :options="treeOptions"
              @node:selected="onNodeSelected"
              @tree:mounted="onTreeMounted">
              <template slot-scope="{ node }">
                <span>
                  <span class="tree-text">
                  {{ node.text }}
                  </span>
                  <Update v-if="Number(categoryId) === Number(node.data.category_id)"
                           :id="node.data.category_id"/>
                </span>
              </template>
            </LiquorTree>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapActions, mapGetters } from 'vuex';
import VuexTypes from '@/store/types/index';
import forEach from 'lodash.foreach';
import LiquorTree from 'liquor-tree';
import Update from './CategoryUpdate.vue';
import Create from './CategoryCreate.vue';

const ProcurementSchemeTypes = VuexTypes.procurementScheme;
export default {
  mounted() {
    this.getData();
  },
  props: ['categoryId'],
  data() {
    return {
      spinners: {
        contentIsLoading: true
      },
      categoriesTree: [],
      treeOptions: {
        multiple: false,
      },
    };
  },
  components: { LiquorTree, Create, Update },
  computed: {
    ...mapGetters('ProcurementScheme', [
      'categoriesList',
      'categoryUpdate',
      'categoryCreate',
    ]),
  },
  watch: {
    categoryId: {
      immediate: true,
      handler() {
        if (!this.categoryId) {
          if (this.$refs.tree) {
            const selection = this.$refs.tree.selected();
            if (selection[0]) {
              selection[0].unselect(true);
            }
          }
        }
      }
    },
    categoriesList: {
      handler: function () {
        if (this.categoriesList['status'] === statuses.LOADING) {
          this.spinners.contentIsLoading = true;
        }
        if (this.categoriesList['status'] === statuses.LOADED) {
          this.spinners.contentIsLoading = false;
          this.fillData();
        }
      },
      deep: true
    },
    categoryUpdate: {
      handler: function () {
        if (this.categoryUpdate.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
        } else if (this.categoryUpdate.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
    categoryCreate: {
      handler: function () {
        if (this.categoryCreate.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
        } else if (this.categoryCreate.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('ProcurementScheme', [
      ProcurementSchemeTypes.CATEGORIES_LIST,
    ]),
    getData() {
      this.CATEGORIES_LIST();
    },
    selectTreeByCategoryId() {
      if (this.$refs.tree) {
        const selection = this.$refs.tree.find({
          data: {
            category_id: Number(this.categoryId)
          }
        });

        if (selection[0]) {
          selection[0].select(true);
          selection[0].expand(true);
          if (selection[0]['parent']) {
            selection[0]['parent'].expand(true);
          }
        }
      }
    },
    fillData() {
      const data = this.categoriesList.data.data;
      const result = [];
      forEach(data, (category) => {
        const item = {
          text: category['name'],
          data: { category_id: category.id, parent_id: null },
          children: []
        };

        if (category.childrens) {
          forEach(category.childrens, (child) => {
            item.children.push({
              text: child['name'],
              data: { category_id: child.id, parent_id: child['parent_id'] },
            });
          });
        }

        result.push(item);
      });
      this.categoriesTree = result;
    },
    onNodeSelected(node) {
      if (this.$route.params.categoryId
        && Number(this.$route.params.categoryId) === Number(node.data.category_id)) {
        return;
      }
      this.$router.push({ name: 'ProcurementScheme', params: { categoryId: node.data.category_id, page: 1 } });
    },
    onTreeMounted() {
      this.selectTreeByCategoryId();
    },
  }
};
</script>
